import { LoadingAndErrorState } from '../LoadingAndErrorState';

export type Us65PlusState = LoadingAndErrorState & {
  granted?: boolean;
};

export const INITIAL_US_65_PLUS_STATE: Us65PlusState = {
  loading: false,
  error: undefined,
  granted: false,
};
